import { IComponentOptions } from "angular";
import { MachinesMoveViewComponentController } from "./controller";
export const vsComponentName = "machinesWarehouse";
export const machinesWarehouseMoveViewComponentOptions: IComponentOptions = {
  controller: MachinesMoveViewComponentController,
  controllerAs: "machinesWarehouseComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machineConfigurations: "<",
  },
};
